module.exports = __webpack_public_path__ + "static/media/Trade Promotions.bd300e66.svg";